// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"6200bd7c","328":"c6372bb3","506":"7ea554aa","775":"d18ffa3e"}[chunkId] + ".chunk.js";
};